import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './store'
import './registerServiceWorker'
import TrendChart from 'vue-trend-chart'
import Moment from 'vue-moment'
// import and include the default style for VuejsDialog
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

axios.defaults.baseURL = process.env.VUE_APP_API_URL
Vue.use(axios)
Vue.use(VuejsDialog)
Vue.use(TrendChart)
Vue.use(Moment)
require('@/store/subscriber') // for localStorage n axios headers

// set a filter to capitalize the first words letter alone
Vue.filter('capitalize', (val) => {
	if(!val) return

	val = val.toString()
	var wordsInVal = val.split(" ")
	var finalWordArr = []
	for(var x = 0; x < wordsInVal.length; x++){
		var wordInitial = wordsInVal[x].slice(0, 1);
		var wordBalance = wordsInVal[x].slice(1, wordsInVal[x].length);
		finalWordArr.push(wordInitial.toUpperCase() + wordBalance)
	}

	return finalWordArr.join(" ")
})

// set a filter to hide credit card numbers leaving only the last four
Vue.filter('mask', (val) => {
	if (!val) return 
	val = val.toString()
	if (val < 4) return ''
	var xxxx = ''
	var lastFour = val.slice(val.length - 4, val.length);
	for(var x=0; x < val.length - 4; x++){
		if(x % 4 == 0){
			xxxx += ' '
		}
		xxxx += 'x'
	}
	return xxxx + ' ' + lastFour
})

// add space after every four characters
Vue.filter('evenlySpaced', (val) => {
	let total = val.length
	let spaced = ''
	let splited = val.split("")
	for(let x=0; x < total; x++){
		if(x % 4 == 0){
			spaced += ' '
		}
		spaced += splited[x]
	}
	return spaced
})

// create a global vue filter for human currency
Vue.filter('money', function (val) {
	if (!val) return '0'
	return val.toLocaleString()
})

// get the time the item was created in time-ago-format
import moment from 'moment'
Vue.filter('postedTimeAgo', function (time) {
	if (!time) return ''
	return moment(time).startOf('hour').fromNow()
})

Vue.config.productionTip = false

export const eventBus = new Vue({
  methods: {
	hideGhostMode(val) {
		this.$emit('hideGhostMode', val)
	},
	gotoStage1(val) {
		this.$emit('gotoStage1', val)
	},
	gotoStage2(val) {
		this.$emit('gotoStage2', val)
	},
	gotoStage3(val) {
		this.$emit('gotoStage3', val)
	},
	gotoReviewPost(val) {
		this.$emit('gotoReviewPost', val)
	}
  }
})

// re-authenticate on user reload & load page after dispatching attempt (you can remove .then(()=>{}))
// by rendering the vue app this way, it ensures that all the state, getters etc are available first yay!
store.dispatch('attempt', localStorage.getItem('_m12tk10q')).then(() => { // _m12tk10q === token
	new Vue({
		router,
		store,
		render: h => h(App)
	}).$mount('#app')
})
